import { useMutation } from "@tanstack/react-query";
import {
  confirmBiometricSigning,
  confirmKnowYourCustomerForm,
  submitAuthenticationData,
  submitContactInformation,
  submitEarningExpense,
  submitIncomeInformation,
  submitPersonalInformation,
  submitPoliticalEffected,
  submitPoliticalEffectedPeople,
} from "./services";
import type {
  AuthenticationTypeSlug,
  IAuthenticationDataRequest,
  IContactInformation,
  IEarningExpense,
  IIncomeInformation,
  IPoliticalEffected,
  IPoliticalEffectedPeople,
  TKnowYourCustomerStepAction,
} from "./types";

export const useSubmitPersonalInformationMutation = () =>
  useMutation({
    mutationFn: submitPersonalInformation,
  });

export const useSubmitContactInformationMutation = () =>
  useMutation({
    mutationFn: (data: IContactInformation) => submitContactInformation(data),
  });

export const useSubmitIncomeInformationMutation = () =>
  useMutation({
    mutationFn: (data: IIncomeInformation) => submitIncomeInformation(data),
  });

export const useSubmitEarningExpenseMutation = () =>
  useMutation({
    mutationFn: (data: IEarningExpense) => submitEarningExpense(data),
  });

export const useSubmitPoliticalEffectedMutation = () =>
  useMutation({
    mutationFn: (data: IPoliticalEffected) => submitPoliticalEffected(data),
  });

export const useSubmitPoliticalEffectedPeopleMutation = () =>
  useMutation({
    mutationFn: (data: IPoliticalEffectedPeople) =>
      submitPoliticalEffectedPeople(data),
  });

export const useConfirmKnowYourCustomerMutation = () =>
  useMutation({
    mutationFn: (step: TKnowYourCustomerStepAction) =>
      confirmKnowYourCustomerForm(step),
  });

export const useAuthenticationDataMutation = (
  authenticationPurpose: string,
  authenticationTypeSlug: AuthenticationTypeSlug,
) =>
  useMutation({
    mutationFn: (data?: IAuthenticationDataRequest) =>
      submitAuthenticationData(
        authenticationPurpose,
        authenticationTypeSlug,
        data,
      ),
  });

export const useConfirmBiometricSigningMutation = () =>
  useMutation({
    mutationFn: confirmBiometricSigning,
  });
